import { Tracing } from "~app/tracing";

const handleAsyncActionError = (error: unknown, context?: string) => {
  console.error(context ?? "Async action failed", error);
  Tracing.capture(error);
};

export const runAsyncAction = (promise: Promise<unknown>, context?: string) => {
  void promise.catch((error) => {
    handleAsyncActionError(error, context);
  });
};
